import axios from 'axios';
import AppConfig from "../../../../config/AppConfig";

function getBaseURL() {
  // return process.env.NODE_ENV === "development" ? 'http://flow123456.com' : 'https://flow.51homemoney.com'
  return AppConfig.meter_server+"/meter/"
}

const instance = axios.create({
  baseURL: getBaseURL() //+ '/meter/'
});

const ErrorResponse = {code: 400, msg: '网络错误'}

instance.interceptors.request.use(function (config) {
  if(!config.params) config.params = {}
  config.params.login = localStorage.getItem('login')
  config.params.token = localStorage.getItem('token')
  return config;
});

function DateFormat(date) {
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let sdate = ("0" + date.getDate()).slice(-2);
  return year + '-' + month + '-' + sdate
}

function get(url, data, callback) {
  instance.get(url, {params: data}).then(resp => {
    callback(resp.data)
  }).catch(error => callback(ErrorResponse))
}

function post(url, data, callback) {
  instance.post(url, data).then(resp => {
    callback(resp.data)
  }).catch(error => callback(ErrorResponse))
}

/**
 * @class MeterHttp
 * @description  meter接口
 * @author xh
 * @date 2024/08/19
 * @version 1.0.0
 * @example
 * MeterHttp.get('/meter/meter/getMeterList',{project_id:1},(resp)=>{})
 * MeterHttp.post('/meter/meter/getMeterList',{project_id:1},(resp)=>{})
 * MeterHttp.enUrl('/meter/meter/getMeterList')
 * MeterHttp.uploadFile((resp)=>{})
 * MeterHttp.selectFile((resp)=>{})
 * @method get,post,enUrl,uploadFile,selectFile
 * @returns {*}
 */
export default class MeterHttp {
  /**
   * 获取基础URL
   * @returns {string}
   */
  static getBaseURL(){
    return getBaseURL()
  }

  /**
   * get请求
   * @param url -请求地址
   * @param data -参数
   * @param callback -回调
   */
  static get(url, data, callback){
    get(MeterHttp.enUrl(url), data, callback)
  }

  /**
   * post请求
   * @param url -请求地址
   * @param data -参数
   * @param callback -回调
   */
  static post(url, data, callback){
    post(MeterHttp.enUrl(url), data, callback)
  }

  /**
   * 转链接
   * @param url -请求地址
   * @returns {string|*}
   */
  static enUrl(url){
    let login = localStorage.getItem('login')
    let token = localStorage.getItem('token')
    if(url.indexOf('http')!==-1){
      return url;
    }else {
      if(url.indexOf("?")===-1){
        return getBaseURL()+url+`?login=${login}&token=${token}`
      }else {
        return getBaseURL()+url+`&login=${login}&token=${token}`
      }
    }
  }

  /**
   * 提交文件
   * @param callback -回调
   */
  static uploadFile(callback){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      let formData = new FormData();
      formData.append("file",this.files[0]);
      axios.post(AppConfig.meter_server+'/meter/index/uploadFile',formData).then(res=>{
        if(res){
          typeof callback==="function"&&callback(res.data.data.path)
        }
      },err=>{

      })

      upload.onchange=undefined;

    }

  }

  /**
   * 选择文件
   * @param callback -回调
   */
  static selectFile(callback){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      callback(this.files[0])
      upload.onchange=undefined;

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/common/MeterHttp.js